// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-menu-container {
    box-shadow:
      4px 6px 10px rgba(220, 220, 220, 0.4),
    -4px 6px 10px rgba(220, 220, 220, 0.4),
      0 6px 10px rgba(220, 220, 220, 0.4);
}`, "",{"version":3,"sources":["webpack://./src/components/widgets/contextMenu/styles.css"],"names":[],"mappings":"AAAA;IACI;;;yCAGqC;AACzC","sourcesContent":[".context-menu-container {\n    box-shadow:\n      4px 6px 10px rgba(220, 220, 220, 0.4),\n    -4px 6px 10px rgba(220, 220, 220, 0.4),\n      0 6px 10px rgba(220, 220, 220, 0.4);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
